import { useEffect } from 'react';
import ReconfirmationPageContent from '../../components/reconfirmation/ReconfirmationPageContent';
import { useSelectedBank, useStepsState } from '../../hooks/zustandHooks';
import { useConsentInfo } from '../../hooks/queryHooks';
import Loader from '../../components/loader/Loader';
import { useTranslation } from 'react-i18next';

const ReconfirmationPage = () => {
  const { consentInfo, isConsentInfoLoading } = useConsentInfo();
  const { selectedBank } = useSelectedBank();
  const bankLogoUrl = selectedBank?.logoUrl;
  const { t } = useTranslation();
  const setActiveStep = useStepsState(state => state.setActiveStep);

  useEffect(() => {
    setActiveStep({ stepIndex: 0 });
    if (window.hj) {
      if (consentInfo) {
        window.hj('tagRecording', [`${consentInfo.consentJourneyType}`]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consentInfo]);

  if (isConsentInfoLoading) {
    return <Loader display={true} spinnerText={t('Loading...')} />;
  }

  return (
    <>
      <ReconfirmationPageContent consentInfo={consentInfo!} bankLogoUrl={bankLogoUrl} />
    </>
  );
};

export { ReconfirmationPage };
export default ReconfirmationPage;
